export default __webpack_public_path__ + "static/media/thumbnail_pm2_monit.1d0bb4a5.jpg";